<template>
  <div class="wrap registration-page">
    <div class="columns">
      <div class="column left-col">
        <div class="auth_block">
          <p><img class="logo_img" src="@/assets/images/logo.png" alt=""></p>
          <h1 class="main_h1">Регистрация</h1>
          <form
            class="col"
            @submit.prevent="formHandler"
          >
            <div class="input-field input-field-last">
              <input
                v-model="email"
                id="email"
                type="email"
                class="validate"
                placeholder="E-mail"
                required
              />
              <span class="helper-text" :data-error="'E-mail обязателен'"></span>
            </div>
            <button ref="submitButton" class="button1" type="submit">
              Зарегистрироваться
            </button>
            <div class="under_login">
              <p><router-link tag="a" to="forgot">Забыли пароль?</router-link></p>
              <p><router-link tag="a" to="login">Авторизация</router-link></p>
            </div>
          </form>
        </div>
      </div>
      <div class="column right-col">
        <div class="right-col-image"></div>
      </div>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";
export default {
  name: "Registration",
  data: () => ({
    email: "",
    password: "",
    state: "register",
    success: true,
    timeout: "",
  }),
  mounted() {
    if (localStorage.getItem("isLogged")) {
      this.$router.replace("/");
    }
    let elems = document.querySelectorAll(".dropdown-trigger");
    M.Dropdown.init(elems);
  },
  methods: {
    forgetSwitcher() {
      this.state = "forget";
      document.getElementById("switcher").textContent = "Войти";
      document.querySelector(".btn").innerHTML = `Восстановить пароль
            <i class="material-icons-outlined right">send</i>`;
    },
    switchState() {
      this.state = this.state == "login" ? "register" : "login";
      this.success = true;
      if (this.state == "login") {
        document.getElementById("switcher").textContent = "Зарегистрироваться";
        document.querySelector(".btn").innerHTML = `Войти
            <i class="material-icons-outlined right">send</i>`;
      } else {
        document.getElementById("switcher").textContent = "Войти";
        document.querySelector(".btn").innerHTML = `Зарегистрироваться
            <i class="material-icons-outlined right">send</i>`;
      }
    },
    formHandler() {
      this.$refs.submitButton.setAttribute("disabled", "disabled");
      this.timeout = setTimeout(
        () => this.$refs.submitButton.removeAttribute("disabled"),
        5000
      );
      if (this.state == "login") {
        fetch("/backend/users.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "login",
            email: this.email,
            password: this.password,
          }),
        })
          .then((res) => res.text())
          .then((confirm) => {
            console.log(confirm);
            if (confirm != "false" && confirm != "deleted") {
              localStorage.setItem("isLogged", confirm);
              clearTimeout(this.timeout);
              this.$router.replace("/");
            } else if (confirm == "deleted") {
              this.email = "";
              this.password = "";
              M.toast({
                html: "Аккаунт удалён. Обратитесь к администратору!",
                displayLength: 8000,
              });
              this.success = false;
            } else {
              this.email = "";
              this.password = "";
              M.toast({
                html: "Неверный адрес электронной почты или пароль",
                displayLength: 8000,
              });
              this.success = false;
            }
          });
      } else if (this.state == "register") {
        fetch("/backend/users.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "create",
            email: this.email.toLowerCase(),
          }),
        })
          .then((res) => res.text())
          .then((rez) => {
            if (rez == "created") {
              M.toast({
                html: "Аккаунт создан",
                displayLength: 8000,
              });
              this.switchState();
            } else if (rez == "mail already exists") {
              this.email = "";
              M.toast({
                html: "Такой адрес уже используется",
                displayLength: 8000,
              });
            }
          });
      } else {
        fetch("/backend/users.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "recover",
            email: this.email,
          }),
        })
          .then((res) => res.text())
          .then((rez) => {
            M.toast({
              html: rez,
              displayLength: 8000,
            });
            console.log(rez);
          });
      }
    },
  },
};
</script>

<style scoped>
.forget {
  text-align: right;
}
.input-field > label {
  transform: translateY(0);
}

</style>
